- section: Skills
  items:

    - id: signet-of-domination
      text: Signet of Domination
      modifiers:
        attributes:
          Condition Damage: [180, buff]
      gw2id: 10232
      temporaryBuff: false

    - id: signet-of-midnight
      text: Signet of Midnight
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation: false
      modifiers:
        attributes:
          Expertise: [180, buff]
      gw2id: 10234
      temporaryBuff: activeOutOfCombat

    - id: lively-lute
      text: Lively Lute
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
      modifiers:
        attributes:
          Outgoing Healing: 10%
        damage:
          Outgoing Strike Damage: [10%, add]
          Outgoing Condition Damage: [10%, add]
      wvwModifiers:
        attributes:
          Outgoing Healing: 5%
        damage:
          Outgoing Strike Damage: [5%, add]
          Outgoing Condition Damage: [5%, add]
      gw2id: 76552
      temporaryBuff: true

- section: Domination
  id: 10
  items:

    - id: empowered-illusions
      text: Empowered Illusions
      modifiers:
        damage:
          Outgoing Phantasm Damage: [15%, unknown]
      gw2id: 682
      defaultEnabled: true

    - id: fragility
      text: Fragility
      minor: true
      amountData:
        label: 'vulnerability'
        default: 25
        quantityEntered: 25
      modifiers:
        damage:
          Outgoing Strike Damage: [12.5%, mult]
      gw2id: 1941
      defaultEnabled: true

    - id: egotism
      text: Egotism
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, mult]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, mult]
      gw2id: 713
      defaultEnabled: true

    - id: vicious-expression
      text: Vicious Expression
      amountData:
        label: '% boonless'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [15%, mult]
          Outgoing Phantasm Damage: [15%, unknown]
      gw2id: 681
      defaultEnabled: true

    - id: power-block-damage
      text: Power Block
      subText: damage
      amountData:
        label: '/10s'
        default: 0
        defaultInput: ???
        quantityEntered: 10
      modifiers:
        attributes:
          NonCrit Power Coefficient: 1035.75
      gw2id: 1688
      temporaryBuff: true
      defaultEnabled: true

    - id: power-block-modifier-severance
      text: Power Block
      subText: modifier (during severance)
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: severance
            group: true
      modifiers:
        damage:
          Outgoing Strike Damage: [25%, add]
      gw2id: 1688
      defaultEnabled: true

    - id: power-block-modifier-no-severance
      text: Power Block
      subText: modifier (not during severance)
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: severance
            group: false
      modifiers:
        damage:
          Outgoing Strike Damage: [25%, add]
      gw2id: 1688
      defaultEnabled: true

- section: Dueling
  id: 1
  items:

    - id: phantasmal-fury
      text: Phantasmal Fury
      subText: normal
      modifiers:
        attributes:
          Phantasm Critical Chance: 25%
      wvwModifiers:
        attributes:
          Phantasm Critical Chance: 20%
      gw2id: 701
      defaultEnabled: false
      temporaryBuff: false

    - id: phantasmal-fury-virtuoso
      text: Phantasmal Fury
      subText: virtuoso
      modifiers:
        attributes:
          Phantasm Critical Chance: 40%
      wvwModifiers:
        attributes:
          Phantasm Critical Chance: 35%
      gw2id: 701
      defaultEnabled: false
      temporaryBuff: false

    - id: phantasmal-fury-virtuoso-bugged
      text: Phantasmal Fury
      subText: 'virtuoso (bugged version)'
      modifiers:
        attributes:
          Phantasm Critical Chance: 35%
      wvwModifiers:
        attributes:
          Phantasm Critical Chance: 30%
      gw2id: 701
      defaultEnabled: false
      temporaryBuff: false

    - id: sharper-images-phantasm
      text: Sharper Images
      subText: phantasm
      minor: true
      amountData:
        label: 'hit/s'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        conversionAfterBuffs:
          Bleeding Coefficient: {Phantasm Critical Chance: 500%}
      gw2id: 710
      defaultEnabled: false
      temporaryBuff: true

    - id: sharper-images-clone
      text: Sharper Images
      subText: clone
      minor: true
      amountData:
        label: 'hit/s'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        conversionAfterBuffs:
          Bleeding Coefficient: {Clone Critical Chance: 500%}
      gw2id: 710
      defaultEnabled: false
      temporaryBuff: true

    - id: fencers-finesse
      text: Fencer's Finesse
      amountData:
        label: 'stacks'
        default: 10
        quantityEntered: 10
      modifiers:
        attributes:
          Ferocity: [150, buff]
      gw2id: 708
      defaultEnabled: true
      temporaryBuff: true

    - id: superiority-complex-base
      text: Superiority Complex
      subText: base
      modifiers:
        damage:
          Outgoing Critical Damage: [15%, mult]
      gw2id: 692
      defaultEnabled: true

    - id: superiority-complex
      text: Superiority Complex
      subText: bonus
      amountData:
        label: '% below 50/disabled'
        default: 50
        quantityEntered: 100
      modifiers:
        damage:
          # increases base version to 25%: 1.25/1.15 = 1.08695652174. see GitHub PR #612.
          Outgoing Critical Damage: [8.695652174%, mult]
      gw2id: 692
      defaultEnabled: true

- section: Chaos
  id: 45
  note: Non-100% Chaotic Potency with-staff values combined with Toxic Maintenance Oil/Enhanced Lucent
    Oil result in inconsistent boon duration between weapon sets, which will be averaged.
  items:

    - id: illusionary-membrane
      text: Illusionary Membrane
      minor: true
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Condition Damage: [7%, add]
      wvwModifiers:
        damage:
          Outgoing Condition Damage: [10%, add]
      gw2id: 667
      defaultEnabled: true

    - id: chaotic-potency
      text: Chaotic Potency
      subText: base
      modifiers:
        attributes:
          Condition Damage: [120, buff]
      gw2id: 669
      defaultEnabled: true
      temporaryBuff: false

    # causes scaled boon duration with toxic oil
    - id: chaotic-potency-2
      text: Chaotic Potency
      subText: with staff
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        attributes:
          Condition Damage: [120, converted] # tested by marcus
      gw2id: 669
      defaultEnabled: false
      temporaryBuff: activeOutOfCombat # sometimes...

    - id: chaotic-persistence
      text: Chaotic Persistence
      minor: true
      amountData:
        label: '% regeneration'
        default: 100
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation: false
      modifiers:
        attributes:
          Concentration: [250, converted]
          Expertise: [100, converted]
          # converted: https://discord.com/channels/380901000200060929/875327743334707251/911570311177207818
      wvwModifiers:
        attributes:
          Concentration: [250, converted]
          Expertise: [250, converted]
      gw2id: 1865
      defaultEnabled: true
      temporaryBuff: true

- section: Inspiration
  id: 23
  items:

    - id: illusionary-inspiration
      text: Illusionary Inspiration
      modifiers:
        attributes:
          Outgoing Healing: 5%
      gw2id: 1866
      defaultEnabled: true
      temporaryBuff: false

- section: Illusions
  id: 24
  items:

    - id: compounding-power
      text: Compounding Power
      amountData:
        label: 'stacks'
        default: 5
        quantityEntered: 5
      modifiers:
        damage:
          Outgoing Strike Damage: [5%, add]
          Outgoing Condition Damage: [5%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
          Outgoing Condition Damage: [10%, add]
      minor: true
      gw2id: 723
      defaultEnabled: true

    - id: Phantasmal Force
      text: Phantasmal Force
      amountData:
        label: 'might'
        default: 25
        quantityEntered: 25
      modifiers:
        damage:
          Outgoing Phantasm Damage: [25%, unknown]
      gw2id: 733
      defaultEnabled: true

    - id: malicious-sorcery
      text: Malicious Sorcery
      modifiers:
        attributes:
          Confusion Duration: 25%
      gw2id: 753
      defaultEnabled: true
      temporaryBuff: false

- section: Chronomancer
  id: 40
  items:

    - id: flow-of-time
      text: Flow of Time
      subText: 100% alacrity
      modifiers:
        attributes:
          Critical Chance: 15%
          Phantasm Critical Chance: 15% # confirmed (despite the trait description saying "you and your clones")
          Clone Critical Chance: 15%
      wvwModifiers:
        attributes:
          Critical Chance: 10%
          Phantasm Critical Chance: 10%
          Clone Critical Chance: 10%
      minor: true
      gw2id: 1927
      defaultEnabled: true
      temporaryBuff: true

    - id: danger-time
      text: Danger Time
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Critical Damage: [5%, mult]
          # the optimizer currently doesn't calculate clone power damage
      wvwModifiers:
        damage:
          Outgoing Critical Damage: [10%, mult]
      gw2id: 2009
      defaultEnabled: true

    - id: danger-time-bugged-critical-chance
      text: Danger Time
      subText: 'bug: additional illusion critical chance (check both)'
      modifiers:
        attributes:
          Phantasm Critical Chance: 15%
          Clone Critical Chance: 15%
      gw2id: 2009
      defaultEnabled: false
      temporaryBuff: true

    - id: chronophantasma
      text: Chronophantasma
      modifiers:
        damage:
          Outgoing Phantasm Damage: [105%, mult]
      wvwModifiers:
        damage:
          Outgoing Phantasm Damage: [50%, mult]
      gw2id: 1890
      defaultEnabled: true

- section: Mirage
  id: 59
  items:

    - id: nomads-endurance
      text: Nomad's Endurance
      amountData:
        label: '% vigor'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
          Outgoing Condition Damage: [5%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
          Outgoing Condition Damage: [10%, add]
      minor: true
      gw2id: 2069
      defaultEnabled: true
      temporaryBuff: true

    - id: phantom-pain
      text: Phantom Pain
      amountData:
        label: 'stacks'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        damage:
          Outgoing Strike Damage: [6.25%, add]
          Outgoing Condition Damage: [5%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [3%, add]
          Outgoing Condition Damage: [3%, add]
      gw2id: 2098
      defaultEnabled: true

    - id: phantom-pain-prenerf
      text: Phantom Pain
      subText: pre-nerf
      amountData:
        label: 'stacks'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        damage:
          Outgoing Strike Damage: [6.25%, add]
          Outgoing Condition Damage: [6.25%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [3%, add]
          Outgoing Condition Damage: [3%, add]
      gw2id: 2098
      defaultEnabled: false

- section: Virtuoso
  id: 66
  note: >-
    With Jagged Mind and Master of Fragmentation, Bladesong Harmony should scale based off of
    "player critical chance plus 25%." The optimizer doesn't support this, but it can be entered as
    if Bladesong Harmony hits are always critical, which will be true with ≥75% player critical
    chance.
  items:

    - id: mental-focus
      text: Mental Focus
      amountData:
        label: '% melee'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [5%, mult] # tested by Snappy Joe
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [7%, mult]
      gw2id: 2208
      defaultEnabled: true

    - id: jagged-mind
      text: Jagged Mind
      subText: per blade hit (including non critical)
      amountData:
        label: 'hit/s'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        conversionAfterBuffs:
          Bleeding Coefficient: {Critical Chance: 400%}
      wvwModifiers:
        conversionAfterBuffs:
          Bleeding Coefficient: {Critical Chance: 300%}
      gw2id: 2202
      defaultEnabled: false
      temporaryBuff: true

    - id: jagged-mind-perma-crit
      text: Jagged Mind
      subText: per always-crits blade hit
      amountData:
        label: 'hit/s'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        attributes:
          Bleeding Coefficient: 4
      wvwModifiers:
        attributes:
          Bleeding Coefficient: 3
      gw2id: 2202
      defaultEnabled: false
      temporaryBuff: true

    # does not affect lifesteal despite "all text" description
    # https://discord.com/channels/380901000200060929/1017105862357176341/1017167619478003792
    - id: deadly-blades
      text: Deadly Blades
      minor: true
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [5%, add]
          Outgoing Condition Damage: [10%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [5%, add]
          Outgoing Condition Damage: [5%, add]
      gw2id: 2204
      defaultEnabled: true

    - id: sharpening-sorrow
      text: Sharpening Sorrow
      subText: 100% fury
      modifiers:
        attributes:
          Expertise: [150, buff]
      gw2id: 2207
      defaultEnabled: true
      temporaryBuff: true

    - id: quiet-intensity
      text: Quiet Intensity
      subText: base
      minor: true
      modifiers:
        conversion:
          Ferocity: {Vitality: 10%}
      gw2id: 2193
      defaultEnabled: true
      temporaryBuff: false

    - id: quiet-intensity-fury
      text: Quiet Intensity
      subText: 100% fury
      minor: true
      modifiers:
        attributes:
          Critical Chance: 15%
      wvwModifiers:
        attributes:
          Critical Chance: 10%
      gw2id: 2193
      defaultEnabled: true
      temporaryBuff: true

    - id: infinite-forge
      text: Infinite Forge
      amountData:
        label: '% strike damage from blade skills'
        default: 0
        defaultInput: ???
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [7%, mult]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, mult]
      gw2id: 2206
      defaultEnabled: true

    - id: bloodsong
      text: Bloodsong
      modifiers:
        damage:
          Outgoing Bleeding Damage: [25%, mult]
      gw2id: 2223
      defaultEnabled: true

- section: Troubadour
  id: 73
  note: >-
    Call and Response damage isn't simulated correctly.
  items:

    - id: shredding
      text: Shredding
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [15%, add]
          Outgoing Condition Damage: [15%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
          Outgoing Condition Damage: [10%, add]
      gw2id: 2343
      defaultEnabled: true

    - id: love-song
      text: Love Song
      subText: while active
      modifiers:
        damage:
          Damage Reduction: [10%, unknown]
      gw2id: 2422
      defaultEnabled: true
      temporaryBuff: true

    - id: fortissimo-1
      text: Fortissimo
      subText: 1 instrument
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: troubadour-instruments
            group: '1'
      modifiers:
        conversion:
          Power: {Power: 4%}
          Precision: {Precision: 4%}
          Toughness: {Toughness: 4%}
          Vitality: {Vitality: 4%}
          Concentration: {Concentration: 4%}
          Condition Damage: {Condition Damage: 4%}
          Expertise: {Expertise: 4%}
          Ferocity: {Ferocity: 4%}
          Healing Power: {Healing Power: 4%}
      gw2id: 2353
      defaultEnabled: true
      temporaryBuff: true

    - id: fortissimo-2
      text: Fortissimo
      subText: 2 instruments
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: troubadour-instruments
            group: '2'
      modifiers:
        conversion:
          Power: {Power: 8%}
          Precision: {Precision: 8%}
          Toughness: {Toughness: 8%}
          Vitality: {Vitality: 8%}
          Concentration: {Concentration: 8%}
          Condition Damage: {Condition Damage: 8%}
          Expertise: {Expertise: 8%}
          Ferocity: {Ferocity: 8%}
          Healing Power: {Healing Power: 8%}
      gw2id: 2353
      defaultEnabled: true
      temporaryBuff: true

    - id: fortissimo-3
      text: Fortissimo
      subText: 3 instruments
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: troubadour-instruments
            group: '3'
      modifiers:
        conversion:
          Power: {Power: 12%}
          Precision: {Precision: 12%}
          Toughness: {Toughness: 12%}
          Vitality: {Vitality: 12%}
          Concentration: {Concentration: 12%}
          Condition Damage: {Condition Damage: 12%}
          Expertise: {Expertise: 12%}
          Ferocity: {Ferocity: 12%}
          Healing Power: {Healing Power: 12%}
      gw2id: 2353
      defaultEnabled: true
      temporaryBuff: true

    - id: fortissimo-4
      text: Fortissimo
      subText: 4 instruments
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: troubadour-instruments
            group: '4'
      modifiers:
        conversion:
          Power: {Power: 16%}
          Precision: {Precision: 16%}
          Toughness: {Toughness: 16%}
          Vitality: {Vitality: 16%}
          Concentration: {Concentration: 16%}
          Condition Damage: {Condition Damage: 16%}
          Expertise: {Expertise: 16%}
          Ferocity: {Ferocity: 16%}
          Healing Power: {Healing Power: 16%}
      gw2id: 2353
      defaultEnabled: true
      temporaryBuff: true

    - id: altered-chord
      text: Altered Chord
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [25%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [15%, add]
      gw2id: 2441
      defaultEnabled: true
